import fa from "element-ui/src/locale/lang/fa";

export default {
  /**
   * ssoStatus是否使用一体化登录  用户：
   * true:使用一体化登录后，只能通过一体化平台登录访问，并且用户和组织结构使用一体化平台的
   * false:不使用一体化登录，还是使用原来的用户，组织结构体系，提供单独的登录页
   */
  ssoStatus: false,

  //预览文件类型
  previewFileTypes: ["docx", "xls", "xlsx", "pdf", "png", "jpg", "jpeg"],
}
